import {Component} from '$src/handy'
import getComparableSaleResearchState from '$src/api/endpoints/comparableSaleResearchState/getComparableSaleResearchState'
import {loadHousingCorporations} from '$src/housingCorporations/HousingCorporationsListPage'
import {serverSnapshotToOurSnapshot} from '$src/comparableSales/sagas/watchAndPersistResearchState'
import {HousingCorporation} from '$src/bootstrap/Store'
import {makeNewEmptyTab} from './Tabs'

const makeEmptyResearchState = (
  housingCorporation: typeof HousingCorporation.Type,
) => {
  const tab = makeNewEmptyTab(housingCorporation)

  return {
    version: 1,
    housingCorporationId: housingCorporation._id,
    tabs: {
      byId: {
        [tab.id]: tab,
      },
      list: [tab.id],
    },
  }
}
const loadResearchState = async (
  comp: Component<unknown, unknown>,
  housingCorporationId: string,
  projectId: string,
) => {
  let researchState: any
  try {
    let [_researchState, _] = await Promise.all([
      comp.callEndpoint(getComparableSaleResearchState, {
        housingCorporationId: housingCorporationId,
      }),
      ,
      ensureHousingCorporationIsLoaded(comp, housingCorporationId, projectId),
    ])

    researchState = _researchState
  } catch (e) {
    throw new Error(e.message || 'Some unkown error happened on the server')
    return
  }

  if (
    !(
      researchState &&
      typeof researchState === 'object' &&
      typeof researchState.version === 'number' &&
      researchState.version > 0
    )
  ) {
    researchState = makeEmptyResearchState(
      comp.store.housingCorporations.byId.get(housingCorporationId) as $FixMe,
    )
  } else {
    researchState = serverSnapshotToOurSnapshot(researchState)
  }

  comp.store.researchStates.set(housingCorporationId, researchState)
}

export default loadResearchState

export const ensureHousingCorporationIsLoaded = async (
  comp: Component<unknown, unknown>,
  housingCorporationId: string,
  projectId: string,
) => {
  if (!comp.store.housingCorporations.byId.has(housingCorporationId)) {
    await loadHousingCorporations(comp, projectId)
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/loadResearchState.ts